import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { createUploadLink } from "apollo-upload-client";
import { setContext } from '@apollo/client/link/context';
import { CgCross } from 'react-icons/cg';
import Data from './json/links.json';

const httpLink = createUploadLink({
  uri: Data.graphqlAPI,
});


const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const typeDefs = gql`
  enum SchoolType {
    UNIVERSITY
    HIGHSCHOOL
  }
`

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  mode: 'no-cors',
  typeDefs,
});
